// CloudFront distribution URL for local development.
// Update this if it needs to be pointed to a different stage.
export const DEV_CLOUDFRONT_URL = 'https://dev.burberry-app.music.amazon.dev';

// Injected at build time by dotenv-webpack (local dev) or left undefined (deployed).
// Used to detect when the app is running locally via a custom /etc/hosts mapping.
export const LOCAL_HOSTNAME: string | undefined = (() => {
  try { return process.env.REACT_APP_LOCAL_HOSTNAME; } catch { return undefined; }
})();

export const STAGE_BETA = 'Beta';
export const STAGE_GAMMA = 'Gamma';
export const STAGE_PROD = 'Prod';
